import { createContext } from "react";
import useLotSummariesByStageId from "../hooks/data/useLotSummariesByStageId";

export interface ILotSummariesContext extends ReturnType<typeof useLotSummariesByStageId> {

};

const LotSummariesContext = createContext<ILotSummariesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default LotSummariesContext